export default __webpack_public_path__ + "static/media/undeadminioncorruptor.9e4f1973.png";